function escapeInput(str) {
  return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');  //eslint-disable-line
}

export { escapeInput }